import {
  GET_TERMINAL_ASSESSMENT_RANKING,
  GET_TERMINAL_ASSESSMENT_RANKING_LOADING,
  CLEAR_TERMINAL_ASSESSMENT_RANKING,
} from "../constants/Type";

const initialState = {
  ranking: null,
  loading: false,
};

const terminalAssessmentRankingReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_TERMINAL_ASSESSMENT_RANKING_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_TERMINAL_ASSESSMENT_RANKING:
      return {
        ...state,
        ranking: payload,
        loading: false,
      };

    case CLEAR_TERMINAL_ASSESSMENT_RANKING:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default terminalAssessmentRankingReducer;
